import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that lags behind by `delayMs` of input idle.
 * Useful for debouncing search queries before firing api calls — without
 * this every keystroke fires a fetch.
 *
 * Example:
 *   const [q, setQ] = useState('');
 *   const debouncedQ = useDebouncedValue(q, 250);
 *   useQuery({ queryKey: ['search', debouncedQ], ... });
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
